import React, { useState } from 'react'
import { useFomaularioStorage } from '../../../storage'
import { escolaridadeAllBack } from '../../../utils'
import { validarUserByCpfApi } from '../../../Api'
import { notify } from '../../Notify'

export default function Certificado2() {
    const { userData } = useFomaularioStorage(state => state.dados)
    const [baixando, setBaixando] = useState(false)
    const [hoverBaixar, setHoverBaixar] = useState(false)

   const textCode = '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'

    const data = Array.isArray(userData) ? userData[0] : userData;

    const nome = data?.nome || '';
    const escolaridadeRaw = data?.escolaridade || '';
    const escolaridade = escolaridadeAllBack[escolaridadeRaw] || escolaridadeRaw;
    const instituicao = data?.instituicao || '';
    const curso = data?.curso || '';
    const rg = data?.rg || '';
    const cpf = data?.cpf || '';
    const dataNascimento = data?.dataNascimento || '';
    const codigoUso = data?.codigoUso || '';
    const imagem = data?.imagem || '';
    const ano = data.ano
 

    const text = ` atesta que ${nome?.toUpperCase()} é estudante e está regularmente matriculado(a) em ${curso?.toUpperCase()} na instituição ${instituicao?.toUpperCase()}.`
    const text2 = 'A UEN Estudantil não se responsabiliza por nenhum tipo de irregularidade na matrícula.'

    // Baixa o PDF assinado pelo certificado ICP-Brasil (.pfx), o mesmo documento
    // validado pelo ValidarController. Reaproveita validarUserByCpfApi.
    const baixarPdfAssinado = async () => {
        if (baixando || !cpf) return
        setBaixando(true)
        try {
            const response = await validarUserByCpfApi({ cpf })
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `${nome || 'carteirinha'}-UEN.pdf`
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)
        } catch (err) {
            console.error('Erro ao baixar PDF assinado:', err)
            notify('Não foi possível gerar o PDF agora. Tente novamente.', 'error')
        } finally {
            setBaixando(false)
        }
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '1000px', // Aumentado para comportar o layout lado a lado no desktop
            backgroundColor: '#fafafa',
            padding: '20px',
            fontFamily: 'sans-serif',
            margin: '20px auto',
            boxSizing: 'border-box',
        }}>
            {/* Título Principal */}
            <h2 style={{ fontSize: '18px', color: '#333', marginBottom: '15px' }}><b>Validação de CIE (Carteira de Identificação Estudantil)</b></h2>

            {/* Banner de Validação */}
            <div style={{
                backgroundColor: '#E1F5EC',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #b8ebcd',
                textAlign: 'center',
                marginBottom: '20px',
            }}>
                <h3 style={{ fontSize: '14px', color: '#00ab3e', margin: 0, fontWeight: '700', letterSpacing: '1px' }}>
                    DOCUMENTO VÁLIDO
                </h3>
            </div>

            {/* Botão de download do PDF assinado (ICP-Brasil / .pfx) */}
            <style>{`@keyframes uenSpin { to { transform: rotate(360deg); } }`}</style>
            <div style={{ marginBottom: '24px' }}>
                <button
                    onClick={baixarPdfAssinado}
                    onMouseEnter={() => setHoverBaixar(true)}
                    onMouseLeave={() => setHoverBaixar(false)}
                    disabled={baixando}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        background: baixando
                            ? 'linear-gradient(135deg, #8fd4b1 0%, #7bc9a5 100%)'
                            : 'linear-gradient(135deg, #00ab3e 0%, #018a34 100%)',
                        color: '#fff',
                        border: 'none',
                        padding: '14px 26px',
                        borderRadius: '12px',
                        fontSize: '14.5px',
                        fontWeight: '700',
                        letterSpacing: '0.2px',
                        cursor: baixando ? 'progress' : 'pointer',
                        boxShadow: hoverBaixar && !baixando
                            ? '0 10px 22px rgba(0, 171, 62, 0.35)'
                            : '0 4px 14px rgba(0, 171, 62, 0.22)',
                        transform: hoverBaixar && !baixando ? 'translateY(-2px)' : 'translateY(0)',
                        transition: 'transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease',
                        outline: 'none',
                    }}
                >
                    {baixando ? (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                            style={{ animation: 'uenSpin 0.8s linear infinite' }} aria-hidden="true">
                            <circle cx="12" cy="12" r="9" stroke="rgba(255,255,255,0.35)" strokeWidth="3" />
                            <path d="M21 12a9 9 0 0 0-9-9" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
                        </svg>
                    ) : (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M12 3v12" />
                            <path d="m7 11 5 5 5-5" />
                            <path d="M5 21h14" />
                        </svg>
                    )}
                    {baixando ? 'Gerando PDF...' : 'Baixar documento assinado (PDF)'}
                </button>
                <div style={{ fontSize: '11.5px', color: '#7a8b83', marginTop: '8px', fontWeight: 500 }}>
                    Documento com assinatura digital ICP-Brasil.
                </div>
            </div>

            {/* Texto de Atestado */}
            <div style={{ fontSize: '12px', color: '#444', textAlign: 'left', marginBottom: '25px', lineHeight: '1.6' }}>
                <b>A UEN Estudantil</b>{text}<br />
                <span style={{ color: '#666' }}>{text2}</span>
            </div>

            <div style={{ width: '100%', borderBottom: '1px solid #eee', marginBottom: '25px' }}></div>

            {/* Seção de Conteúdo Flexível (Lado a Lado no Desktop / Empilhado no Mobile) */}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap', // Isso faz com que quebre a linha no mobile
                gap: '30px',
            }}>
                
                {/* Lado Esquerdo: Dados e Foto */}
                <div style={{ flex: '1 1 400px', display: 'flex', gap: '20px' }}>
                    {imagem && (
                        <img
                            src={imagem}
                            alt="Foto"
                            style={{ width: '110px', height: '140px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                    )}
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '10px' }}>Dados do estudante:</div>
                        <InfoField label="Nome:" value={nome} />
                        <InfoField label="CPF/CIN:" value={formatarCPF(cpf)} />
                        <InfoField label="Data de Nascimento:" value={dataNascimento} />
                        <InfoField label="Curso:" value={curso?.toUpperCase()} />
                        <InfoField label="Instituição:" value={instituicao?.toUpperCase()} />
                        <InfoField label="Código de uso:" value={codigoUso} />
                        <InfoField label="Emissor:" value="UEN" />
                    </div>
                </div>

                {/* Lado Direito: Certificado de Atributo */}
                <div style={{ flex: '1 1 400px' }}>
                    <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '10px' }}>Certificado de Atributo:</div>
                    <CertificateDisplay title={'-----BEGIN ATTRIBUTE CERTIFICATE-----'} content={textCode} />
                </div>
            </div>
        </div>
    )
}

function InfoField({ label, value }) {
    return (
        <div style={{ marginBottom: '6px', fontSize: '13px', color: '#333' }}>
            <b style={{ marginRight: '4px' }}>{label}</b> {value}
        </div>
    )
}

function formatarCPF(cpf) {
    if (!cpf) return '';
    const cleanCpf = cpf.replace(/\D/g, '');
    return cleanCpf
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

const CertificateDisplay = ({ title, content }) => {
    return (
        <div style={{
            backgroundColor: '#F3F6F9',
            padding: '15px',
            borderRadius: '6px',
            fontFamily: 'monospace',
            fontSize: '10px',
            lineHeight: '1.2',
            wordBreak: 'break-all',
            color: '#555',
            border: '1px solid #e0e6ed'
        }}>
            <div style={{ color: '#999', textAlign: 'center', marginBottom: '10px' }}>{title}</div>
            {content}
            <div style={{ color: '#999', textAlign: 'center', marginTop: '10px' }}>-----END ATTRIBUTE CERTIFICATE-----</div>
        </div>
    )
}